// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_cj-j";
export var fulfillmentFormRail = "_cj-i";
export var headerTitleRow = "_cj-l";
export var orderDetailsWrapper = "_cj-g";
export var orderLinkTrigger = "_cj-2";
export var paymentInformationGrid = "_cj-q";
export var paymentSummaryColumn = "_cj-r";
export var phoneShipmentPickerButton = "_cj-e";
export var phoneShipmentPickerButtonContent = "_cj-f";
export var phoneShipmentPickerButtonWrapper = "_cj-d";
export var phoneShipmentPickerTrigger = "_cj-c";
export var shipmentContainer = "_cj-k";
export var shipmentDetailsMainPane = "_cj-h";
export var shipmentNavigationCard = "_cj-a";
export var shipmentNavigationEdgeTrigger = "_cj-6";
export var shipmentNavigationRail = "_cj-3";
export var shipmentNavigationRailEnter = "_cj-5";
export var shipmentNavigationRailHeader = "_cj-9";
export var shipmentNavigationRailOverlay = "_cj-4";
export var shipmentNavigationScrim = "_cj-7";
export var shipmentSummaryFact = "_cj-n";
export var shipmentSummaryGrid = "_cj-m";
export var shipmentSummaryMetadataRow = "_cj-o";
export var shipmentSummaryTags = "_cj-p";
export var shipmentWorkspace = "_cj-0";
export var shipmentWorkspaceBodyTablet = "_cj-8";
export var shipmentWorkspaceContent = "_cj-b";
export var shipmentWorkspaceHeader = "_cj-1";